export default __webpack_public_path__ + "static/media/island.4bf94602.jpg";